export default "__VITE_PUBLIC_ASSET__91696f64__"